<template>

  <h1>{{moduleData.main_title}}</h1>

  <ul
  class="list-group"
  >
    <template
        v-for="(item) in moduleData.structure"
    >
      <li
          class="list-group-item"
          v-if="item.type == 'string'"
      >
        {{item.title}}: {{item.value}}
      </li>
      <li
          class="list-group-item"
          v-else-if="item.type == 'list'"
      >
        {{item.title}}<br/>
        <ul
            v-if="item.value"
            class="list-group ms-3"
        >
          <li
           v-for="(listItem, indexItem) in item.value"
           class="list-group-item"
          >
            <template
              v-if="item.description[indexItem]"
            >
              {{item.description[indexItem]}}:
            </template>
            <template
                v-else
            >
              [{{indexItem}}]:
            </template>
            <span v-html="listItem"></span>
          </li>
        </ul>
      </li>


      <li
          v-else
          class="list-group-item"
      >
        <display-debug>
          <template #debugView>
            ITEM {{item}}
          </template>
        </display-debug>

      </li>




    </template>

  </ul>



  <display-debug>
    <template #debugView>
     INFO MODULE {{moduleData.structure}}
    </template>
  </display-debug>



  <!--
  <component
      v-bind:is="moduleData.view"
      :dataObj="moduleData.data"
      v-model:reloadSignal="reloadSignalList"
  ></component>


  [--component start2]
  <view-custom
      :dataObj="moduleData.data"
  >

  </view-custom>
  [--component end2]


  <h2>{{moduleData.title}}</h2>






  -->
  <!--
  [component start]
  <component
      v-bind:is="moduleData.view"
      :dataObj="moduleData.data"
  ></component>

  [component end]
  -->
  <!--
        :dataObj="moduleData.data"
  <form-general
      form-title="Nazev formulare"
      :form-obj="moduleData.form"
      original-path="$router.currentRoute.originalPath"

  >
  </form-general>
  -->
</template>

<script>
import { defineAsyncComponent } from 'vue';
import ViewGeneral from "@/components/general/view/ViewGeneral";
import ViewOrder from "@/components/general/view/ViewOrder";
import ViewTimeline from "@/components/general/view/ViewTimeline";
import ViewReservations from "@/components/general/view/ViewReservations";

import ViewFlashMessageDetail from "@/components/general/view/ViewFlashMessageDetail";
import ViewFlashMessageUserList from "@/components/general/view/ViewFlashMessageUserList";

export default {
  name: "ViewModule",
  components: {
    ViewGeneral,
    ViewOrder,
    ViewTimeline,
    ViewReservations,
    ViewFlashMessageDetail,
    ViewFlashMessageUserList
    /*
    LatestBox: defineAsyncComponent(() => import('@/components/general/view/ViewOrder.vue')),
    ViewCustom: () => import('@/components/general/view/'+ 'ViewOrder' +'.vue').catch((error) => {
      console.error('Chyba při načítání komponenty:', error); //this.moduleData.view
    })*/
  },
  emits: [
    "update:reloadSignal"
  ],
  props: {
    "ident": String,
    "reloadSignal": String,
    "moduleData": Object,
    "route": Object,
    "config": [Object],
  },
  data() {
    return {
      myComponentName: 'Goal', // Název komponenty uložený v proměnné
      reloadSignalBox: null,
      reloadSignalList: null
    }
  },
  methods: {
      reloadParent(val) {
        this.$emit("update:reloadSignal", val);
      }
  },
  watch: {
    reloadSignalBox: {
      handler(val) {
        //this.reloadParent(val);
      },
      immediate: true
    },
    reloadSignalList: {
      handler(val) {
        this.reloadParent(val);
      },
      immediate: true
    },
  },
  created() {

  },
  mounted() {
   // console.log("dev DashboardModule mounted x")
  }
};
</script>